import MinLength from './min-length'

export default MinLength
